import React from 'react';
import PropTypes from 'prop-types';
import Tabs from '../../reusable/Tabs/Tabs';

const TabsHeader = ({ tab, onChange }) => {
  return <Tabs tab={tab} handleTabChange={onChange} type="campaign" />;
};

TabsHeader.propTypes = {
  tab: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default TabsHeader;
